import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Building2 } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { api, errMsg } from "@/lib/api";
import { Btn, DoorMark, ErrorText, Field, Input } from "@/components/kit";

export default function CreateOrg() {
  const { me, refresh, signOut } = useAuth();
  const navigate = useNavigate();
  const [name, setName] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    setError("");
    try {
      await api.post("/orgs", { name });
      await refresh();
      navigate("/projects", { replace: true });
    } catch (err) {
      setError(errMsg(err));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="flex min-h-screen items-center justify-center bg-[#F6F7F5] px-6">
      <div className="w-full max-w-[440px] space-y-6 fade-in">
        <div className="flex items-center gap-2">
          <DoorMark className="h-5 w-5 text-[#3B4446]" />
          <span className="font-display text-lg font-bold">Condoor</span>
        </div>
        <div className="rounded-lg border border-[#DDE2DF] bg-white p-6">
          <Building2 className="h-5 w-5 text-[#0F5E59]" />
          <h1 className="mt-3 font-display text-xl font-bold" data-testid="create-org-heading">Create your organization</h1>
          <p className="mt-1 text-[13.5px] text-[#5B6567]">
            Welcome, {me?.user?.name}. Your organization owns its documents, review context, and member permissions.
            You'll be its administrator.
          </p>
          <form onSubmit={submit} className="mt-5 space-y-4">
            <Field label="Organization name">
              <Input value={name} onChange={(e) => setName(e.target.value)} required placeholder="e.g. Acme Hardware"
                data-testid="create-org-name-input" autoFocus />
            </Field>
            <ErrorText data-testid="create-org-error">{error}</ErrorText>
            <Btn variant="primary" type="submit" loading={busy} data-testid="create-org-submit-button">Create organization</Btn>
          </form>
        </div>
        <button className="text-[13px] text-[#5B6567] hover:underline" onClick={async () => { await signOut(); navigate("/"); }}
          data-testid="create-org-sign-out">
          Sign out
        </button>
      </div>
    </div>
  );
}
